var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notifications-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Bell_Line",
    "data-name": "icons/Bell/Line",
    transform: "translate(4.332 3.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-2-line_1",
    "data-name": "notification-2-line 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.335,12.8a.753.753,0,0,1-.753.753H.753a.753.753,0,0,1,0-1.506H.767V6.8A6.851,6.851,0,0,1,7.668,0a6.851,6.851,0,0,1,6.9,6.8v5.247h.014A.753.753,0,0,1,15.335,12.8ZM2.3,12.046H13.035V6.8A5.368,5.368,0,0,0,2.3,6.8Zm3.874,3.438c-.447-.546.149-1.179.855-1.179H8.307c.706,0,1.3.633.855,1.179a1.911,1.911,0,0,1-.138.152,1.942,1.942,0,0,1-2.711,0A1.911,1.911,0,0,1,6.174,15.485Z",
    fill: "#6b6b95"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNotificationsIcon);
export default __webpack_public_path__ + "static/media/menuNotificationsIcon.6cf41d6b506e13cab15b8e8a3f9ca227.svg";
export { ForwardRef as ReactComponent };